import React, { useEffect, useState } from "react";
import MaintanenceItemData from "./MiniComponents/MaintanenceItemData/MaintanenceItemData";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getStandardMaintenanceItemsById } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";

export default function MaintenanceItem() {
  const dispatch = useDispatch();
  const { itemId } = useParams();
  const { detailsStandardMaintenanceItemsById, status, error } = useSelector((state) => state.standardMaintenanceItems);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (itemId) {
      setLoading(true);
      dispatch(getStandardMaintenanceItemsById(itemId))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [itemId, dispatch]);

  if (loading) {
    return (
      <div className="main">
        <section className="companyProfile">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-white">جاري التحميل...</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (status === "failed" && error) {
    return (
      <div className="main">
        <section className="companyProfile">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-danger">حدث خطأ: {error.message || "غير معروف"}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="main">
      <section className="companyProfile">
        <div className="container-fluid">
          <div className="row">
            {detailsStandardMaintenanceItemsById?.children?.length > 0 ? (
              detailsStandardMaintenanceItemsById.children.map((item) => <MaintanenceItemData key={item.id} item={item} />)
            ) : (
              <div className="col-12 text-center">
                <p className="text-white">لا توجد عناصر فرعية متاحة</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
